import { Container, Grid, styled } from '@mui/material'

import { BackgroundIcon } from 'src/utils/Icon'
import Color from 'src/utils/Color'

type WrapperProps = {
  isBackgroundImage: boolean
}

export const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isBackgroundImage',
})<WrapperProps>((props) => ({
  borderTop: `7px solid ${Color.containerBorderTop}`,
  backgroundColor: props.isBackgroundImage ? 'white' : Color.backgroundColor,
  backgroundImage: props.isBackgroundImage ? `url(${BackgroundIcon.Blue})` : 'none',
  backgroundSize: '2%',
  backgroundRepeat: 'repeat-x',
  boxSizing: 'border-box',
  minHeight: window.innerHeight - 7,
  width: '100vw',

  [props.theme.breakpoints.down('sm')]: {
    borderTop: `4px solid ${Color.containerBorderTop}`,
    minHeight: window.innerHeight - 4,
    backgroundSize: '10%',
  },
}))

export const BuildingWrapper = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isBackgroundImage',
})<WrapperProps>((props) => ({
  minHeight: window.innerHeight - 7,
  backgroundImage: props.isBackgroundImage ? `url(${BackgroundIcon.Building})` : 'none',
  backgroundPosition: 'center bottom',
  backgroundRepeat: 'repeat-x',
  backgroundSize: '100%',

  [props.theme.breakpoints.down('sm')]: {
    backgroundSize: '180%',
    minHeight: window.innerHeight - 4,
  },
}))

export const FullHeightContainer = styled(Container)({
  height: '100%',
})
